import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const AdminPanelClientListHeader = ({
  orderBy,
  order,
  handleChangeOrder,
}) => {
  const intl = useIntl();

  const handleSetOrder = (e, newOrderBy) => {
    e.preventDefault();
    if (newOrderBy === orderBy) {
      handleChangeOrder(newOrderBy, order === 'asc' ? 'desc' : 'asc');
    } else {
      handleChangeOrder(newOrderBy, newOrderBy === 'name' ? 'asc' : 'desc');
    }
  };

  return (
    <tr>
      <th className={`th-sortable${orderBy === 'name' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { handleSetOrder(e, 'name'); }}>
          {intl.formatMessage({ defaultMessage: 'Name' })}
          {' '}
          {orderBy === 'name' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th className={`th-sortable${orderBy === 'created_at' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { handleSetOrder(e, 'created_at'); }}>
          {intl.formatMessage({ defaultMessage: 'Created' })}
          {' '}
          {orderBy === 'created_at' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Plan' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Users / activated' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Storage limit' })}
      </th>
      <th className={`th-sortable${orderBy === 'total_file_size' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { handleSetOrder(e, 'total_file_size'); }}>
          {intl.formatMessage({ defaultMessage: 'Storage usage' })}
          {' '}
          {orderBy === 'total_file_size' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th>
        {' '}
      </th>
    </tr>
  );
};

AdminPanelClientListHeader.propTypes = {
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
};

export default AdminPanelClientListHeader;
